module.exports = __webpack_public_path__ + "img/avatar1.4c1202ec.jpg";